import { useEffect, useState } from "react";
import MDBox from "common/components/MD/MDBox";
import { Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab } from "@mui/material";
import MDTypography from "common/components/MD/MDTypography";
import MDInput from "common/components/MD/MDInput";
import AuthService from "services/API/Auth/AuthService";
import ERService from 'services/API/ExpoRichieste/ExpoRichiesteService.js';
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import MDButton from "common/components/MD/MDButton";
//validazione lato client
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { brandFabSx } from "common/assets/theme/components/brandButtonSx";

function ExpoRichiestaPDFEdit({ id_richiesta }) {

    const [prop, setProp] = useState({

        idRichiesta: 0,
        id_utente: AuthService.getCurrentUser().id,


    });
    const [file_rx,setFile_rx]=useState();


    useEffect(() => {
        if (id_richiesta != null && id_richiesta !== 0) {
            console.log("soggetto non nullo: id=" + id_richiesta);
            seleziona_soggetto();
        } else {
            console.log("soggetto nullo");
        }
    }, []);

    async function seleziona_soggetto() {
        console.log("Cambiata pp->seleziono i dettagli :" + id_richiesta);
        if (id_richiesta !== 0) {
            const response = await ERService.selezionaPDF(id_richiesta);
            response.errors ? console.log(response.errors) : retrive(response.data);
        }
    }




    function retrive(data) {

        setProp({
            idRichiesta: data.idRichiesta,
            id_utente: data.id_utente,
            nome_pdf_proposta: data.nome_pdf_proposta,
            stato_accettazione:data.stato_accettazione
        });
        setFile_rx(data.nome_pdf_proposta);
        console.log("selezionata  " + prop.idRichiesta);

    }



    async function download_pdf() {
        console.log("download_pdf x richiesta :" + id_richiesta);
        if (id_richiesta !== 0) {
            let filename = 'PropostaDiPartecipazioneAgriumbria2025.pdf';

            ERService.download_pdf(id_richiesta)
                .then(response => {

                    return response.data;
                })
                .then(blob => {

                    var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
                    var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
                    var url = URL.createObjectURL(blobb);
                    var a = document.createElement('a');
                    a.href = url;
                    a.target = "_blank";
                    a.download = filename;
                    document.body.appendChild(a); // append the element to the dom
                    a.click();
                    a.remove(); // afterwards, remove the element  
                })
                .catch(error => {
                    console.error(error);
                });


        }
    }

    const visualizza_pdf = () => {
        if (id_richiesta !== 0) {
            let filename = prop.nome_pdf_proposta;

            ERService.scaricaPDFProposta(id_richiesta)
                .then(response => {

                    return response.data;
                })
                .then(blob => {

                    var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
                    var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
                    var url = URL.createObjectURL(blobb);
                    var a = document.createElement('a');
                    a.href = url;
                    a.target = "_blank";
                    a.download = filename;
                    document.body.appendChild(a); // append the element to the dom
                    a.click();
                    a.remove(); // afterwards, remove the element  
                })
                .catch(error => {
                    console.error(error);
                });


        }
    };


    const [open2, setOpen2] = useState(false);
    const [confirm2, setConfirm2] = useState(false);
    function handleClose2() {
        setOpen2(false);
    }

    function handleConfirm2() {
        setConfirm2(true);
        setOpen2(false);
        elimina_pdf();
    }


    const handleOpen2 = () => {
        console.log("OPEN DIALOG");
        setOpen2(true);
    }

    function elimina_pdf() {

        ERService.elimina_pdf(prop.idRichiesta)
           .then(response => {
                    handleResponse(response, 'DELETED');
                    setFile_rx(null);
                    seleziona_soggetto();
                })
                .catch(errore => {
                    handleError(errore);
                });


    }

    /* ----------------------------VALIDAZIONE E SALVATAGGIO----------------------------------------------------------------------- */


    const validationSchema = Yup.object().shape({
        pdf_proposta: Yup.mixed()
            .required("Devi caricare un file")
            .test("fileSize", "Il file è troppo grande o non c'è!", (file) => {
                //if u want to allow only certain file sizes
                return file && file[0] && file[0].size <= 2000000;
            })

    });



    /* ----------------------------SALVATAGGIO E REGISTRAZIONE------------------------------------------------- */


    const {
        register, //register inputs
        reset, setValue, control,
        handleSubmit,//handle form submit
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });




    const [error, setError] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
   const [ok, setOk] = useState(null);
    const [okMessage, setOkMessage] = useState(null);



    const inserisci_pp = (formData) => {
        if (AuthService.isTokenOk()) {
            setError(null);

            var data = {
                idRichiesta: prop.idRichiesta,
                id_utente: AuthService.getCurrentUser().id,
                manifestazione: prop.manifestazione,
                pdf_proposta: formData.pdf_proposta,


            };

            ERService.salva_pdf(prop.idRichiesta, data)
                .then(response => {
                    handleResponse(response, 'SENT');
                    setFile_rx(formData.pdf_proposta);
                    seleziona_soggetto();
                })
                .catch(errore => {
                    handleError(errore);
                });

        }

    }

    function handleResponse(response, op) {
        //  console.log(response.data);
        setOk("OK");     
        setOkMessage("Operazione "+op+" completata con successo!");
 


    }


    function handleError(error) {
        setError(error);
        console.log("ERRORE" + error);
        console.log(error.code);

        if (error.response) {
            console.log("ERROR:RESPONSE" + error.response.data);
            setErrorMessage(error.response.data);

        } else if (error.request) {
            console.log("EEROR:REQUEST" + error.request);
            setErrorMessage(error.request);
        } else {
            console.log('Error', error.message);
            setErrorMessage(error.message);
        }

    }


    return (

        <MDBox>

            <Dialog open={open2} onClose={handleClose2} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
                <DialogTitle id="alert-dialog-title">
                    Eliminare il PDF ?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Sei sicuro di voler eliminare il pdf ricevuto ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={handleClose2}>No</MDButton>
                    <MDButton onClick={handleConfirm2} autoFocus>
                        SI
                    </MDButton>
                </DialogActions>
            </Dialog>



            <MDBox pt={1} pb={3} px={3} component="form" role="form">

                {file_rx &&
                    <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 2fr 2fr' }}>
                        <MDTypography variant="h6">Nome file Ricevuto : {prop.nome_pdf_proposta}</MDTypography>
                        <Fab variant="extended" size="medium" onClick={visualizza_pdf} sx={brandFabSx}> 
                             <VisibilityIcon sx={{ mr: 1 }} aria-hidden="true"/>Vedi il PDF Caricato
                        </Fab>
                        {prop.stato_accettazione==="NON LAVORATO" &&
                        <Fab variant="extended" size="medium" onClick={handleOpen2}  sx={brandFabSx}> 
                            <DeleteForeverIcon sx={{ mr: 1 }} aria-hidden="true" />Elimina il PDF Caricato
                        </Fab>}
                    </MDBox>}

                <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '1fr 1fr 1fr 1fr' }}>
                    <Fab variant="extended" size="medium" onClick={download_pdf} sx={brandFabSx}> 
                        <DownloadIcon sx={{ mr: 1 }} aria-hidden="true"/>Rigenera il PDF
                    </Fab>







                </MDBox>
                   {ok !== null &&
                    <Alert color="success"  mb={3}><ErrorOutlineOutlinedIcon fontSize="small" />&nbsp;{okMessage}</Alert>}
          
                {error !== null &&
                    <Alert color="error"  mb={3}><ErrorOutlineOutlinedIcon fontSize="small" />&nbsp;{errorMessage}</Alert>

                }

                {!file_rx &&
                    <MDBox my={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr ' }}>

                        <MDInput
                            type="file"
                            label="Proposta di partecipazione" fullWidth required
                            autocomplete="off"  {...register('pdf_proposta')}
                            name="pdf_proposta" InputLabelProps={{ shrink: true }}

                        />
                        <Fab variant="extended"  size="medium" onClick={handleSubmit(inserisci_pp)} sx={brandFabSx}> 
                         <FileUploadIcon sx={{ mr: 1 }} aria-hidden="true" />Salva
                        </Fab>
                        {
                            errors.pdf_proposta ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.pdf_proposta?.message}</span> : ''
                        }
                    </MDBox>

                }

            </MDBox></MDBox>

    );

}

export default ExpoRichiestaPDFEdit;